module.exports = __webpack_public_path__ + "static/media/internet.2f51778a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/media/assets/internet.svg
// module id = 121
// module chunks = 0